import React, { useRef, useEffect, useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

import { PhoneVideoContainer, PhoneVideoPosition } from './phone.video.styles';

interface PhoneVideoBlock {
  videoUrl: string;
}

const PhoneVideo = ({ videoUrl }: PhoneVideoBlock): JSX.Element => {

  const [ showVideo, setShowVideo ] = useState(false);

  const srcRel = useRef<HTMLSourceElement>(null);
  const videoRel = useRef<HTMLVideoElement>(null);
  const data: any = useStaticQuery(graphql`{
  mockup: file(relativePath: {eq: "phone-mockup.png"}) {
    childImageSharp {
      gatsbyImageData(width: 400, layout: CONSTRAINED, placeholder: BLURRED)
    }
  }
  poster: file(relativePath: {eq: "phone-poster.jpeg"}) {
    childImageSharp {
      gatsbyImageData(width: 400, layout: CONSTRAINED, placeholder: BLURRED)
    }
  }
}
`)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (document.body.offsetWidth > 500) {
        setShowVideo(true)
      }
    }
  }, [ videoRel ])

  useEffect(() => {
    if (showVideo) {
      if (!!videoRel && !!srcRel && !!srcRel.current && (typeof window !== 'undefined')) {
        setTimeout(() => {
          if (srcRel.current?.dataset?.src) {
            srcRel.current.src = srcRel.current.dataset.src;
            videoRel.current.load();
          }
        }, 1500)
      }
    }
  }, [ srcRel, videoRel, showVideo ])

  return (
    <PhoneVideoContainer>
      <GatsbyImage image={data.mockup.childImageSharp.gatsbyImageData} alt={'Phone mockup'} />
      <PhoneVideoPosition>
        <GatsbyImage image={data.poster.childImageSharp.gatsbyImageData} alt={'App sample'} />
        {
          !showVideo ? null :
            <video ref={videoRel} preload="none" width="100%" autoPlay={true} playsInline={true} muted={true} loop={true} >
              <source ref={srcRel} data-src={videoUrl} type="video/mp4" style={{ background: 'white' }} />
            </video>
        }
      </PhoneVideoPosition>
    </PhoneVideoContainer>
  );
};

export default PhoneVideo;
